import React, { useEffect, useState, useRef } from 'react';
import { Space, Table, DatePicker, Button } from 'antd';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../database/firebase';
import { activitateInScoala } from './zileLibere';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import {
  getVacante,
  vacante1,
  vacante2,
  zileLibere,
  recuperari,
} from './zileLibere';
import { displayName } from 'react-quill';
const { RangePicker } = DatePicker;
const formatDate = (today) => {
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;

  return dd + '.' + mm + '.' + yyyy;
};
const CondicaExport = ({
  startDate,
  endDate,
  print = false,
  condicaProfi,
  valeaSpinului,
  perCadru,
  vacante,
}) => {
  const [condica, setCondica] = useState([]);
  const componentRef = useRef();
  const [concedii, setConcedii] = useState([]);
  const profesori = useSelector((state) => state.profesori);
  const materii = useSelector((state) => state.materii);
  const clase = useSelector((state) => state.clase);
  const [semnaturi, setSemnaturi] = useState({});
  const settings = useSelector((state) => state.settings);
  const vc = vacante2;
  useEffect(() => {
    let sem = {};
    const fetchSemnaturi = async () => {
      for await (let prof of profesori) {
        if (prof.semnatura) {
          let semnaturaLink = prof.semnatura;
          const response = await fetch(semnaturaLink);
          const blob = await response.blob();

          // Creează un URL local din blob și setează-l în state
          const localUrl = URL.createObjectURL(blob);
          sem[prof.id] = localUrl;
        } else sem[prof.id] = 'prezent';
      }
      setSemnaturi(sem);
    };
    fetchSemnaturi();
  }, [profesori]);

  console.log({ profesori });
  const retriveHourCorectly = (date, type, startDate, dataObj = null) => {
    // Transformă timestamp-ul în ora României
    const roDate = new Date(
      date.toLocaleString('en-US', { timeZone: 'Europe/Bucharest' })
    );

    const hour = roDate.getHours();
    const minutes = roDate.getMinutes();

    // Special handling for Școala Gimnazială "Mihai Eminescu" Năsăud
    if (
      process.env.REACT_APP_NAME === `Școala Gimnazială "Mihai Eminescu" Năsăud`
    ) {
      const periods = [
        {
          period: 1,
          start: '8:00',
          end: '8:50',
          pause: '8:50',
          pauseEnd: '9:00',
        },
        {
          period: 2,
          start: '9:00',
          end: '9:50',
          pause: '9:50',
          pauseEnd: '10:00',
        },
        {
          period: 3,
          start: '10:00',
          end: '10:50',
          pause: '10:50',
          pauseEnd: '11:00',
        },
        {
          period: 4,
          start: '11:00',
          end: '11:50',
          pause: '11:50',
          pauseEnd: '12:00',
        },
        {
          period: 5,
          start: '12:00',
          end: '12:50',
          pause: '12:50',
          pauseEnd: '13:00',
        },
        {
          period: 6,
          start: '13:00',
          end: '13:40',
          pause: '13:40',
          pauseEnd: '14:00',
        },
        {
          period: 7,
          start: '14:00',
          end: '14:40',
          pause: '14:40',
          pauseEnd: '14:45',
        },
        {
          period: 8,
          start: '14:45',
          end: '15:25',
          pause: '15:25',
          pauseEnd: '15:35',
        },
        {
          period: 9,
          start: '15:35',
          end: '16:15',
          pause: '16:15',
          pauseEnd: '16:20',
        },
        {
          period: 10,
          start: '16:20',
          end: '17:00',
          pause: '17:00',
          pauseEnd: '17:05',
        },
        {
          period: 11,
          start: '17:05',
          end: '17:45',
          pause: '17:45',
          pauseEnd: '17:50',
        },
        { period: 12, start: '17:50', end: '18:30', pause: '', pauseEnd: '' },
      ];

      const currentTime = hour * 60 + minutes;

      for (let period of periods) {
        const [startHour, startMin] = period.start.split(':').map(Number);
        const [endHour, endMin] = period.end.split(':').map(Number);
        const startTime = startHour * 60 + startMin;
        const endTime = endHour * 60 + endMin;

        if (currentTime >= startTime && currentTime <= endTime) {
          if (type === 'start') {
            return period.start;
          } else if (type === 'end') {
            return period.end;
          }
        }
      }
    }

    // Special handling for SGMVT
    if (process.env.REACT_APP_NAME === 'SGMVT') {
      console.log('intru aici sff?');
      // Check if it's a preparatory or primary class (Pregatitoare, I, II, III, IV)
      const currentClass = clase?.find((cls) => cls.id === dataObj?.classId);
      const isPrimaryClass =
        currentClass &&
        ['Pregatitoare', 'Pregătitoare', 'I', 'II', 'III', 'IV'].includes(
          currentClass.anClasa
        );

      // Also check if classId contains primary class info for grouped entries
      const hasGroupedPrimaryClass =
        dataObj?.classId &&
        typeof dataObj.classId === 'string' &&
        dataObj.classId.includes(' + ') &&
        (dataObj.classId.includes('Pregătitoare') ||
          dataObj.classId.includes('Pregatitoare') ||
          dataObj.classId.match(/\b(I|II|III|IV)\s/));

      const shouldUsePrimarySchedule = isPrimaryClass || hasGroupedPrimaryClass;
      const endMinute = shouldUsePrimarySchedule ? '45' : '50';

      // Debug log
      if (dataObj?.materieId?.includes('Religie')) {
        console.log('SGMVT Religie Debug:', {
          classId: dataObj?.classId,
          currentClass: currentClass,
          anClasa: currentClass?.anClasa,
          isPrimaryClass,
          shouldUsePrimarySchedule,
          endMinute,
        });
      }

      const periods = [
        {
          period: 1,
          start: '8:00',
          end: `8:${endMinute}`,
          pause: `8:${endMinute}`,
          pauseEnd: '9:00',
        },
        {
          period: 2,
          start: '9:00',
          end: `9:${endMinute}`,
          pause: `9:${endMinute}`,
          pauseEnd: '10:00',
        },
        {
          period: 3,
          start: '10:00',
          end: `10:${endMinute}`,
          pause: `10:${endMinute}`,
          pauseEnd: '11:00',
        },
        {
          period: 4,
          start: '11:00',
          end: `11:${endMinute}`,
          pause: `11:${endMinute}`,
          pauseEnd: '12:00',
        },
        {
          period: 5,
          start: '12:00',
          end: `12:${endMinute}`,
          pause: `12:${endMinute}`,
          pauseEnd: '13:00',
        },
        {
          period: 6,
          start: '13:00',
          end: `13:${endMinute}`,
          pause: `13:${endMinute}`,
          pauseEnd: '14:00',
        },
        {
          period: 7,
          start: '14:00',
          end: `14:${endMinute}`,
          pause: `14:${endMinute}`,
          pauseEnd: '14:45',
        },
        {
          period: 8,
          start: '15:00',
          end: `15:${endMinute}`,
          pause: `15:${endMinute}`,
          pauseEnd: '15:00',
        },
      ];

      const currentTime = hour * 60 + minutes;

      for (let period of periods) {
        const [startHour, startMin] = period.start.split(':').map(Number);
        const [endHour, endMin] = period.end.split(':').map(Number);
        const startTime = startHour * 60 + startMin;
        const endTime = endHour * 60 + endMin;

        if (currentTime >= startTime && currentTime <= endTime) {
          console.log('BRUH', period.end);
          if (type === 'start') {
            return period.start;
          } else if (type === 'end') {
            // For primary classes, replace :50 with :45
            if (shouldUsePrimarySchedule && period.end.endsWith(':50')) {
              return period.end.replace(':50', ':45');
            }
            return period.end;
          }
        }
      }
    }

    // Default behavior for other schools
    if (type === 'start') {
      if (hour < 11 || process.env.REACT_APP_PAUZA_MARE === 'no') {
        return (hour < 10 ? '0' : '') + hour + ':00';
      } else {
        return hour + ':10';
      }
    }

    if (type === 'end') {
      const minutes = roDate.getMinutes();

      // Dacă se termină cu :50 și ora >= 11 și PAUZA_MARE ≠ "no"
      if (
        minutes === 50 &&
        hour >= 11 &&
        process.env.REACT_APP_PAUZA_MARE !== 'no'
      ) {
        // Crește ora cu +1 și pune :00
        return hour + 1 + ':00';
      } else {
        // Altfel păstrează ora și minutele ca sunt
        const hourStr = hour < 10 ? '0' + hour : hour;
        const minuteStr = minutes < 10 ? '0' + minutes : minutes;
        return hourStr + ':' + minuteStr;
      }
    }
  };
  const fetchDataForMonth = async (year, month) => {
    let array = [];
    for await (let profesorData of profesori) {
      const querySnapshot = await getDocs(
        collection(db, profesorData.id + 'condica' + month + 'an' + year)
      );

      querySnapshot.forEach((doc) => {
        array.push({
          ...doc.data(),
          uuid: doc.id,
          startDate: new Date(doc.data().startDate),
          endDate: new Date(doc.data().endDate),
          displayName: profesorData.numeDeFamilie + ' ' + profesorData.prenume,
          profId: profesorData.id,
        });
      });
    }
    setCondica((prevCondica) => [...prevCondica, ...array]);
  };

  const fetchAllData = async () => {
    let current = dayjs(startDate);

    while (current.isBefore(endDate) || current.isSame(endDate, 'month')) {
      await fetchDataForMonth(current.year(), current.toDate().getMonth());
      current = current.add(1, 'month');
    }

    const querySnapshotConcedii = await getDocs(collection(db, 'concedii'));
    let arrayNou = [];
    querySnapshotConcedii.forEach((doc) => {
      arrayNou.push({
        ...doc.data(),
        startDate: new Date(doc.data().startDate),
        endDate: new Date(doc.data().endDate),
        id: doc.id,
      });
    });
    setConcedii(arrayNou);
  };

  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (startDate && endDate) {
      setCondica([]); // Resetează condica pentru a evita duplicările
      setIsDataLoaded(false);
      fetchAllData().then(() => {
        // Add a small delay to ensure data is fully processed
        setTimeout(() => {
          setIsDataLoaded(true);
        }, 500);
      });
    }
  }, [startDate, endDate]);

  const generateDates = (start, end) => {
    const dates = [];
    let currentDate = new Date(start);
    while (currentDate <= end) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const zile = generateDates(new Date(startDate), new Date(endDate));

  const formatterLuna = new Intl.DateTimeFormat('ro-RO', { month: 'long' });

  const concediu = (data, standalones, profId) => {
    if (typeof data === 'number' || typeof data === 'string')
      data = new Date(data);

    if (
      (concedii || []).find(
        (c) =>
          c.prof === profId &&
          c.startDate.getTime() <= data &&
          c.endDate.getTime() >= data &&
          (!standalones.getHours ||
            (retriveHourCorectly(standalones, 'start', null, standalones) >=
              (c.stringDates?.[0] || '00:00') &&
              retriveHourCorectly(standalones, 'start', null, standalones) <=
                (c.stringDates?.[1] || '23:59')))
      )?.text === 'CONCEDIU MEDICAL'
    )
      return { color: 'red' };
    if (
      (concedii || []).find(
        (c) =>
          c.prof === profId &&
          c.startDate.getTime() <= data &&
          c.endDate.getTime() >= data &&
          (!data.getHours ||
            (retriveHourCorectly(data, 'start', null, data) >=
              (c.stringDates?.[0] || '00:00') &&
              retriveHourCorectly(data, 'start', null, data) <=
                (c.stringDates?.[1] || '23:59')))
      )?.text === 'CONCEDIU'
    )
      return { color: 'green' };
    return {};
  };

  const columns = [
    {
      title: 'Data',
      dataIndex: 'Data',
      key: 'data',
      render: (e, data) => {
        if (data.zi)
          return (
            <p
              style={{
                ...concediu(data.zi, data.startDate, data.profId),
                fontSize: '12px',
                paddingLeft: '2px',
                marginLeft: '2px',
                ...(data.marked &&
                  {
                    // backgroundColor: "#fffae6",
                    // borderLeft: "3px solid orange",
                    // fontWeight: "bold",
                    // fontSize: "20px",
                  }),
              }}
            >
              {data.rezerva === true
                ? '      '
                : new Date(data.zi).toLocaleDateString('ro-RO')}
            </p>
          );
        return (
          <p
            style={{
              ...concediu(data.zi, data.startDate, data.profId),
              fontSize: '12px',
              padddingLeft: '3px',
            }}
          >
            {data.rezerva === true
              ? '      '
              : data.startDate.toLocaleDateString('ro-RO')}
          </p>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Interval',
      dataIndex: 'interval',
      key: 'interval',
      render: (e, data) => {
        if (
          data.tip === 'toataziua' ||
          data.tip === 'activitate' ||
          data.saptamanaAltfel
        )
          return (
            <p
              style={{
                ...concediu(data.zi, data.startDate, data.profId),
                fontSize: '12px',
              }}
            >
              -
            </p>
          );
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : retriveHourCorectly(data.startDate, 'start', null, data)}
            </p>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : retriveHourCorectly(
                    data.endDate,
                    'end',
                    data.startDate,
                    data
                  )}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Clasa',
      dataIndex: 'Clasa',
      key: 'clasa',
      render: (e, data) => {
        if (data.tip === 'toataziua' || data.tip === 'activitate')
          return <p>-</p>;
        return (
          <>
            {data.tip === 'privat' ? (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.classId.split(' - ')[1]}
              </p>
            ) : (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.classId && data.classId.includes(' + ')
                  ? data.classId
                  : clase?.find((cls) => cls.id === data.classId)?.anClasa +
                    ' ' +
                    clase?.find((cls) => cls.id === data.classId)
                      ?.identificator}
              </p>
            )}
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Disciplina',
      dataIndex: 'Materie',
      key: 'Materie',
      render: (e, data) => {
        return (
          <>
            {data.tip === 'activitate' ? (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                Activitate în școală
              </p>
            ) : data.tip === 'privat' ? (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.textOra ||
                    data.classId.split(' - ')[0] ||
                    data.materieId ||
                    (data.saptamanaVerde
                      ? 'Saptamana verde, conform orarului'
                      : data.saptamanaAltfel
                      ? 'Saptamana altfel, conform orarului'
                      : data.vacanta
                      ? '-'
                      : 'Activitate în școală ')}
              </p>
            ) : (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.adec === true
                  ? 'Activități de educație complementară'
                  : data.saptamanaVerde
                  ? 'Saptamana verde'
                  : data.saptamanaAltfel
                  ? 'Scoala altfel'
                  : data.vacanta && process.env.REACT_APP_NAME === 'SGMVT'
                  ? '-'
                  : materii?.find((m) => m.id === data.materieId)?.numeMaterie
                  ? materii?.find((m) => m.id === data.materieId)?.numeMaterie
                  : data?.subiectLectie}
              </p>
            )}
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Nume și prenume',
      dataIndex: 'prof',
      key: 'prof',
      render: (e, data) => {
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true ? '      ' : data.displayName}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },

    {
      title: 'Semnătură',
      key: 'tip',
      render: (_, data) => {
        if (semnaturi[data.profId] === 'prezent')
          return (
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {concedii?.find(
                (c) =>
                  c.prof === data.profId &&
                  c.startDate.getTime() <=
                    (data.zi || data.startDate?.getTime()) &&
                  c.endDate.getTime() >=
                    (data.zi || data.startDate?.getTime()) &&
                  (!data.startDate.getHours ||
                    (retriveHourCorectly(data.startDate, 'start', null, data) >=
                      (c.stringDates?.[0] || '00:00') &&
                      retriveHourCorectly(
                        data.startDate,
                        'start',
                        null,
                        data
                      ) <= (c.stringDates?.[1] || '23:59')))
              )?.text ||
                (data.rezerva === true
                  ? '      '
                  : data.tip === 'activitate'
                  ? 'prezent'
                  : data.ziLibera && data.recuperare !== true
                  ? 'Z.L.L'
                  : data.vacanta && data.recuperare !== true
                  ? 'Concediu de odihnă'
                  : process.env.REACT_APP_NAME !== 'SGMVT' &&
                    process.env.REACT_APP_NAME !==
                      'Liceul Teoretic Sanitar Bistrita'
                  ? 'prezent'
                  : '    ')}
            </p>
          );
        else {
          if (
            Object.keys(
              concediu(data.zi || data.startDate, data.startDate, data.profId)
            ).length > 0
          ) {
            return (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : concedii?.find(
                      (c) =>
                        c.prof === data.profId &&
                        c.startDate.getTime() <=
                          (data.zi || data.startDate?.getTime()) &&
                        c.endDate.getTime() >=
                          (data.zi || data.startDate?.getTime()) &&
                        (!data.startDate.getHours ||
                          (retriveHourCorectly(
                            data.startDate,
                            'start',
                            null,
                            data
                          ) >= (c.stringDates?.[0] || '00:00') &&
                            retriveHourCorectly(
                              data.startDate,
                              'start',
                              null,
                              data
                            ) <= (c.stringDates?.[1] || '23:59')))
                    )?.text ||
                    (data.tip === 'activitate'
                      ? 'prezent'
                      : process.env.REACT_APP_NAME !== 'SGMVT' &&
                        process.env.REACT_APP_NAME !==
                          'Liceul Teoretic Sanitar Bistrita'
                      ? '       '
                      : 'prezent    ')}
              </p>
            );
          } else
            return data.rezerva === true ? (
              <p style={{ height: '30px' }}>{'      '}</p>
            ) : (
              <img
                src={semnaturi[data.profId]}
                style={{ width: '100px', height: '30px' }}
              />
            );
        }
      },
      responsive: ['sm'],
    },
  ];

  const columnsRecuperare = [
    {
      title: 'Data',
      dataIndex: 'Data',
      key: 'data',
      render: (e, data) => {
        if (data.zi)
          return (
            <p
              style={{
                ...concediu(data.zi, data.startDate, data.profId),
                fontSize: '12px',
                paddingLeft: '2px',
                marginLeft: '2px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : new Date(data.zi).toLocaleDateString('ro-RO')}
            </p>
          );
        return (
          <p
            style={{
              ...concediu(data.zi, data.startDate, data.profId),
              fontSize: '12px',
              padddingLeft: '3px',
            }}
          >
            {data.rezerva === true
              ? '      '
              : data.startDate.toLocaleDateString('ro-RO')}
          </p>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Interval',
      dataIndex: 'interval',
      key: 'interval',
      render: (e, data) => {
        if (
          data.tip === 'toataziua' ||
          data.tip === 'activitate' ||
          data.saptamanaAltfel
        )
          return (
            <p
              style={{
                ...concediu(data.zi, data.startDate, data.profId),
                fontSize: '12px',
              }}
            >
              -
            </p>
          );
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : retriveHourCorectly(data.startDate, 'start', null, data)}
            </p>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : retriveHourCorectly(
                    data.endDate,
                    'end',
                    data.startDate,
                    data
                  )}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Clasa',
      dataIndex: 'Clasa',
      key: 'clasa',
      render: (e, data) => {
        if (data.tip === 'toataziua' || data.tip === 'activitate')
          return <p>-</p>;
        return (
          <>
            {data.tip === 'privat' ? (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.classId.split(' - ')[1]}
              </p>
            ) : (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.classId && data.classId.includes(' + ')
                  ? data.classId
                  : clase?.find((cls) => cls.id === data.classId)?.anClasa +
                    ' ' +
                    clase?.find((cls) => cls.id === data.classId)
                      ?.identificator}
              </p>
            )}
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Disciplina',
      dataIndex: 'Materie',
      key: 'Materie',
      render: (e, data) => {
        return (
          <>
            {data.tip === 'activitate' ? (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                Activitate în școală
              </p>
            ) : data.tip === 'privat' ? (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.textOra ||
                    data.classId.split(' - ')[0] ||
                    data.materieId ||
                    (data.saptamanaVerde
                      ? 'Saptamana verde, conform orarului'
                      : data.saptamanaAltfel
                      ? 'Saptamana altfel, conform orarului'
                      : data.vacanta
                      ? '-'
                      : 'Activitate în școală')}
              </p>
            ) : (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : data.adec === true
                  ? 'Activități de educație complementară'
                  : data.saptamanaVerde
                  ? 'Saptamana verde'
                  : data.saptamanaAltfel
                  ? 'Scoala altfel'
                  : data.vacanta
                  ? '-'
                  : materii?.find((m) => m.id === data.materieId)
                      ?.numeMaterie || 'Activitate în școală'}
              </p>
            )}
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Nume și prenume',
      dataIndex: 'prof',
      key: 'prof',
      render: (e, data) => {
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true ? '      ' : data.displayName}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Recuperat în data de',
      dataIndex: 'recuperat',
      key: 'recuperat',
      render: (e, data) => {
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {'      '}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Semnătură',
      key: 'tip',

      render: (_, data) => {
        if (semnaturi[data.profId] === 'prezent')
          return (
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : concedii?.find(
                    (c) =>
                      c.prof === data.profId &&
                      c.startDate.getTime() <=
                        (data.zi || data.startDate?.getTime()) &&
                      c.endDate.getTime() >=
                        (data.zi || data.startDate?.getTime()) &&
                      (!data.startDate.getHours ||
                        (retriveHourCorectly(
                          data.startDate,
                          'start',
                          null,
                          data
                        ) >= (c.stringDates?.[0] || '00:00') &&
                          retriveHourCorectly(
                            data.startDate,
                            'start',
                            null,
                            data
                          ) <= (c.stringDates?.[1] || '23:59')))
                  )?.text ||
                  (data.rezerva === true
                    ? '      '
                    : data.tip === 'activitate'
                    ? 'prezent'
                    : data.ziLibera && data.recuperare !== true
                    ? 'Z.L.L'
                    : data.vacanta && data.recuperare !== true
                    ? 'Concediu de odihnă'
                    : process.env.REACT_APP_NAME !== 'SGMVT' &&
                      process.env.REACT_APP_NAME !==
                        'Liceul Teoretic Sanitar Bistrita'
                    ? 'prezent'
                    : '    ')}
            </p>
          );
        else {
          if (
            Object.keys(
              concediu(data.zi || data.startDate, data.startDate, data.profId)
            ).length > 0
          ) {
            return (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : concedii?.find(
                      (c) =>
                        c.prof === data.profId &&
                        c.startDate.getTime() <=
                          (data.zi || data.startDate?.getTime()) &&
                        c.endDate.getTime() >=
                          (data.zi || data.startDate?.getTime()) &&
                        (!data.startDate.getHours ||
                          (retriveHourCorectly(
                            data.startDate,
                            'start',
                            null,
                            data
                          ) >= (c.stringDates?.[0] || '00:00') &&
                            retriveHourCorectly(
                              data.startDate,
                              'start',
                              null,
                              data
                            ) <= (c.stringDates?.[1] || '23:59')))
                    )?.text ||
                    (data.rezerva === true
                      ? '      '
                      : data.tip === 'activitate'
                      ? 'prezent'
                      : process.env.REACT_APP_NAME !== 'SGMVT' &&
                        process.env.REACT_APP_NAME !==
                          'Liceul Teoretic Sanitar Bistrita'
                      ? '       '
                      : 'prezent    ')}
              </p>
            );
          } else
            return data.rezerva === true ? (
              '      '
            ) : (
              <img
                src={semnaturi[data.profId]}
                style={{ width: '100px', height: '30px' }}
              />
            );
        }
      },
      responsive: ['sm'],
    },
  ];
  const columnsActivitate = [
    {
      title: 'Data',
      dataIndex: 'Data',
      key: 'data',
      render: (e, data) => {
        if (data.zi)
          return (
            <p
              style={{
                ...concediu(data.zi, data.startDate, data.profId),
                fontSize: '12px',
                paddingLeft: '2px',
                marginLeft: '2px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : new Date(data.zi).toLocaleDateString('ro-RO')}
            </p>
          );
        return (
          <p
            style={{
              ...concediu(data.zi, data.startDate, data.profId),
              fontSize: '12px',
              padddingLeft: '3px',
            }}
          >
            {data.rezerva === true
              ? '      '
              : data.startDate.toLocaleDateString('ro-RO')}
          </p>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Nume și prenume',
      dataIndex: 'prof',
      key: 'prof',
      width: '40%',
      render: (e, data) => {
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true ? '      ' : data.displayName}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      width: '30%',
      title: 'Text',
      dataIndex: 'recuperat',

      key: 'recuperat',
      render: (e, data) => {
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
                height: '30px',
              }}
            >
              {'      '}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },
    {
      title: 'Semnătură',
      key: 'tip',
      render: (_, data) => {
        if (semnaturi[data.profId] === 'prezent')
          return (
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.rezerva === true
                ? '      '
                : concedii?.find(
                    (c) =>
                      c.prof === data.profId &&
                      c.startDate.getTime() <=
                        (data.zi || data.startDate?.getTime()) &&
                      c.endDate.getTime() >=
                        (data.zi || data.startDate?.getTime()) &&
                      (!data.startDate.getHours ||
                        (retriveHourCorectly(
                          data.startDate,
                          'start',
                          null,
                          data
                        ) >= (c.stringDates?.[0] || '00:00') &&
                          retriveHourCorectly(
                            data.startDate,
                            'start',
                            null,
                            data
                          ) <= (c.stringDates?.[1] || '23:59')))
                  )?.text ||
                  (data.rezerva === true
                    ? '      '
                    : data.tip === 'activitate'
                    ? 'prezent'
                    : data.ziLibera && data.recuperare !== true
                    ? 'Z.L.L'
                    : data.columnsActivitate
                    ? '     '
                    : data.vacanta && data.recuperare !== true
                    ? 'Concediu de odihnă'
                    : process.env.REACT_APP_NAME !== 'SGMVT' &&
                      process.env.REACT_APP_NAME !==
                        'Liceul Teoretic Sanitar Bistrita'
                    ? 'prezent'
                    : '    ')}
            </p>
          );
        else {
          if (
            Object.keys(
              concediu(data.zi || data.startDate, data.startDate, data.profId)
            ).length > 0
          ) {
            return (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {data.rezerva === true
                  ? '      '
                  : concedii?.find(
                      (c) =>
                        c.prof === data.profId &&
                        c.startDate.getTime() <=
                          (data.zi || data.startDate?.getTime()) &&
                        c.endDate.getTime() >=
                          (data.zi || data.startDate?.getTime()) &&
                        (!data.startDate.getHours ||
                          (retriveHourCorectly(
                            data.startDate,
                            'start',
                            null,
                            data
                          ) >= (c.stringDates?.[0] || '00:00') &&
                            retriveHourCorectly(
                              data.startDate,
                              'start',
                              null,
                              data
                            ) <= (c.stringDates?.[1] || '23:59')))
                    )?.text ||
                    (data.rezerva === true
                      ? '      '
                      : data.tip === 'activitate'
                      ? 'prezent'
                      : process.env.REACT_APP_NAME === 'SGMVT' &&
                        process.env.REACT_APP_NAME ===
                          'Liceul Teoretic Sanitar Bistrita'
                      ? '       '
                      : 'prezent    ')}
              </p>
            );
          } else
            return data.rezerva === true ? (
              <p style={{ height: '30px' }}>{'      '}</p>
            ) : (
              <img
                src={semnaturi[data.profId]}
                style={{ width: '100px', height: '30px' }}
              />
            );
        }
      },
      responsive: ['sm'],
    },
  ];
  const columnsAdmin = [
    {
      title: 'Data',
      dataIndex: 'Data',
      key: 'data',
      render: (e, data) => {
        if (data.zi)
          return (
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {new Date(data.zi).toLocaleDateString('ro-RO')}
            </p>
          );
        return (
          <p
            style={{
              ...concediu(
                data.zi || data.startDate,
                data.startDate,
                data.profId
              ),
              fontSize: '12px',
            }}
          >
            {data.startDate.toLocaleDateString('ro-RO')}
          </p>
        );
      },
      responsive: ['sm'],
    },

    {
      title: 'Nume și prenume',
      dataIndex: 'prof',
      key: 'prof',
      render: (e, data) => {
        return (
          <>
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {data.displayName}
            </p>
          </>
        );
      },
      responsive: ['sm'],
    },

    {
      title: 'Semnătură',
      key: 'tip',
      render: (_, data) => {
        if (semnaturi[data.profId] === 'prezent')
          return (
            <p
              style={{
                ...concediu(
                  data.zi || data.startDate,
                  data.startDate,
                  data.profId
                ),
                fontSize: '12px',
              }}
            >
              {concedii?.find(
                (c) =>
                  c.prof === data.profId &&
                  c.startDate.getTime() <=
                    (data.zi || data.startDate?.getTime()) &&
                  c.endDate.getTime() >=
                    (data.zi || data.startDate?.getTime()) &&
                  (!data.startDate.getHours ||
                    (retriveHourCorectly(data.startDate, 'start', null, data) >=
                      (c.stringDates?.[0] || '00:00') &&
                      retriveHourCorectly(
                        data.startDate,
                        'start',
                        null,
                        data
                      ) <= (c.stringDates?.[1] || '23:59')))
              )?.text ||
                (data.tip === 'activitate'
                  ? 'prezent'
                  : data.vacanta
                  ? 'Concediu de odihnă'
                  : 'prezent ' +
                    (profesori?.find((p) => data?.profId == p.id)?.programAdmin
                      ? 'în timpul programului de muncă ' +
                        profesori?.find((p) => data?.profId == p.id)
                          ?.programAdmin[
                          (new Date(data.startDate).getDay() + 6) % 7
                        ]
                      : ''))}
            </p>
          );
        else {
          if (
            Object.keys(
              concediu(data.zi || data.startDate, data.startDate, data.profId)
            ).length > 0
          ) {
            return (
              <p
                style={{
                  ...concediu(
                    data.zi || data.startDate,
                    data.startDate,
                    data.profId
                  ),
                  fontSize: '12px',
                }}
              >
                {concedii?.find(
                  (c) =>
                    c.prof === data.profId &&
                    c.startDate.getTime() <=
                      (data.zi || data.startDate?.getTime()) &&
                    c.endDate.getTime() >=
                      (data.zi || data.startDate?.getTime()) &&
                    (!data.startDate.getHours ||
                      (retriveHourCorectly(
                        data.startDate,
                        'start',
                        null,
                        data
                      ) >= (c.stringDates?.[0] || '00:00') &&
                        retriveHourCorectly(
                          data.startDate,
                          'start',
                          null,
                          data
                        ) <= (c.stringDates?.[1] || '23:59')))
                )?.text ||
                  (data.tip === 'activitate'
                    ? 'prezent'
                    : data.vacanta
                    ? 'Concediu de odihnă'
                    : 'prezent ' +
                      (profesori?.find((p) => data.profId == p.id)?.programAdmin
                        ? 'în timpul programului de muncă ' +
                          profesori?.find((p) => data.profId == p.id)
                            ?.programAdmin[
                            ((data.zi || data.startDate).getDate() + 6) % 7
                          ]
                        : ''))}
              </p>
            );
          } else
            return data.rezerva === true ? (
              '      '
            ) : (
              <img
                src={semnaturi[data.profId]}
                style={{ width: '100px', height: '30px' }}
              />
            );
        }
      },
      responsive: ['sm'],
    },
  ];

  function compareDates(a, b) {
    let dayA = a.startDate.getDay();
    let dayB = b.startDate.getDay();

    let hourA = a.startDate.getHours();
    let hourB = b.startDate.getHours();

    let minuteA = a.startDate.getMinutes();
    let minuteB = b.startDate.getMinutes();

    // Comparăm ziua săptămânii
    if (dayA > dayB) {
      return 1;
    } else if (dayA < dayB) {
      return -1;
    }

    // Comparăm ora dacă zilele sunt egale
    if (hourA > hourB) {
      return 1;
    } else if (hourA < hourB) {
      return -1;
    }

    // Comparăm minutele dacă orele sunt egale
    if (minuteA > minuteB) {
      return 1;
    } else if (minuteA < minuteB) {
      return -1;
    }

    // Dacă ziua, ora și minutele sunt egale
    return 0;
  }
  // Show loading message if data is not ready
  if (!isDataLoaded || condica.length === 0) {
    return (
      <div className='condica-export'>
        <div ref={componentRef}>
          <p style={{ textAlign: 'center', padding: '20px' }}>
            Se încarcă datele pentru condică...
          </p>
        </div>
      </div>
    );
  }

  if (condicaProfi && perCadru === true)
    return (
      <div className='condica-export'>
        <div ref={componentRef}>
          {[
            ...profesori
              .filter((p) => {
                if (
                  process.env.REACT_APP_NAME !==
                  `Școala Gimnazială "Mihai Eminescu" Năsăud`
                )
                  return true;
                if (valeaSpinului) {
                  // Show professors who have at least one class with "VS"
                  if (
                    p?.ore?.find((o) =>
                      clase
                        .find((c) => c.id === o.classId)
                        ?.identificator.includes('VS')
                    )
                  )
                    return true;
                } else {
                  // Show professors who have at least one class without "VS"
                  if (
                    p?.ore?.find(
                      (o) =>
                        !clase
                          .find((c) => c.id === o.classId)
                          ?.identificator.includes('VS')
                    )
                  )
                    return true;
                }
                return false;
              })
              .filter(
                (p) =>
                  p?.selectedMaterii?.length === 0 ||
                  !p?.selectedMaterii ||
                  p?.selectedMaterii?.find((m) => !m.includes('Admin'))
              ),
          ]
            .sort((a, b) => {
              if (a.numeDeFamilie + a.prenume < b.numeDeFamilie + b.prenume)
                return -1;
              else return 1;
            })
            .map((p) => {
              const condicaP = condica.filter((c) => c.profId === p.id);
              return (
                <>
                  <h3
                    style={{ textAlign: 'center', pageBreakBefore: 'always' }}
                  >
                    {p.numeDeFamilie + ' ' + p.prenume}
                  </h3>
                  <h4 style={{ textAlign: 'center' }}>
                    {formatDate(new Date(startDate)) +
                      ' - ' +
                      formatDate(new Date(endDate))}
                  </h4>
                  <br />
                  <br />

                  <div>
                    <Table
                      columns={columns}
                      dataSource={zile
                        .reduce((acc, current) => {
                          let ziLibera = false;
                          if (
                            zileLibere?.find((C) => {
                              return (
                                current.getDate() === C.getDate() &&
                                current.getMonth() === C.getMonth() &&
                                current.getFullYear() === C.getFullYear()
                              );
                            })
                          )
                            ziLibera = true;
                          let vacanta = false;
                          if (
                            getVacante().find((d) => {
                              let start = new Date(d.s.getTime());
                              let end = new Date(d.e.getTime());
                              start.setUTCHours(0, 0, 0, 0);
                              end.setUTCHours(0, 0, 0, 0);
                              let dt = current;
                              if (start <= dt && end >= dt) return true;
                              return false;
                            })
                          )
                            vacanta = true;
                          let acis = false;
                          if (
                            activitateInScoala?.find((d) => {
                              let start = new Date(d.s.getTime());
                              let end = new Date(d.e.getTime());
                              start.setUTCHours(0, 0, 0, 0);
                              end.setUTCHours(0, 0, 0, 0);
                              let dt = current;
                              if (start <= dt && end >= dt) return true;
                              return false;
                            })
                          )
                            acis = true;
                          const zileCurente = condicaP
                            .filter(
                              (c) =>
                                current.getDate() ===
                                  new Date(c.zi || c.startDate).getDate() &&
                                current.getMonth() ===
                                  new Date(c.zi || c.startDate).getMonth() &&
                                current.getFullYear() ===
                                  new Date(c.zi || c.startDate).getFullYear() &&
                                (vacante === true ||
                                  (vacante === false && c.vacanta !== true))
                            )
                            .map((p) => ({
                              ...p,
                              ziLibera,
                              vacanta,
                              columnsActivitate: acis,
                            }));

                          // Dacă este activitate în școală și nu avem alte intrări, adaugă o intrare cu "- - - -"
                          if (acis && zileCurente?.length === 0) {
                            zileCurente.push({
                              id:
                                current.getDate() +
                                'zi' +
                                current.getMonth() +
                                'an' +
                                current.getFullYear() +
                                'acis',
                              profId: p.id,
                              displayName: p.numeDeFamilie + ' ' + p.prenume,
                              startDate: current,
                              zi: current,
                              tip: 'activitate',
                              materieId: 'Activitate în școală',
                              classId: '-',
                              columnsActivitate: acis,
                              ziLibera,
                              vacanta,
                            });
                          }

                          return [...acc, ...zileCurente];
                        }, [])
                        .sort((a, b) => {
                          if (
                            new Date(
                              a?.zi || a?.startDate.getTime()
                            ).toLocaleDateString() ===
                            new Date(
                              b?.zi || b?.startDate.getTime()
                            ).toLocaleDateString()
                          ) {
                            // Put "Activități în completare" at the end
                            const aIsActivitati =
                              a?.numeMaterie === 'Activități în completare';
                            const bIsActivitati =
                              b?.numeMaterie === 'Activități în completare';

                            if (aIsActivitati && !bIsActivitati) return 1;
                            if (!aIsActivitati && bIsActivitati) return -1;

                            return (
                              a?.startDate.getHours() - b?.startDate.getHours()
                            );
                          }
                          return (
                            new Date(a?.zi || a?.startDate.getTime()) -
                            new Date(b?.zi || b?.startDate.getTime())
                          );
                        })}
                      pagination={false}
                    />
                  </div>
                </>
              );
            })}
        </div>
      </div>
    );
  else if (perCadru === true)
    return (
      <div className='condica-export'>
        <div ref={componentRef}>
          {[
            ...profesori.filter((p) =>
              p?.selectedMaterii?.find((m) => m.includes('Admin'))
            ),
          ]
            .sort((a, b) => {
              if (a.numeDeFamilie + a.prenume < b.numeDeFamilie + b.prenume)
                return -1;
              else return 1;
            })
            .map((p) => {
              const condicaP = condica.filter((c) => c.profId === p.id);
              return (
                <>
                  <h3
                    style={{ textAlign: 'center', pageBreakBefore: 'always' }}
                  >
                    {p.numeDeFamilie + ' ' + p.prenume}
                  </h3>

                  <div>
                    <Table
                      columns={columnsAdmin}
                      dataSource={zile
                        .reduce((acc, current) => {
                          let acis = false;
                          if (
                            activitateInScoala?.find((d) => {
                              let start = new Date(d.s.getTime());
                              let end = new Date(d.e.getTime());
                              start.setUTCHours(0, 0, 0, 0);
                              end.setUTCHours(0, 0, 0, 0);
                              let dt = current;
                              if (start <= dt && end >= dt) return true;
                              return false;
                            })
                          )
                            acis = true;
                          return [
                            ...acc,
                            ...condicaP
                              .filter(
                                (c) =>
                                  current.getDate() ===
                                    new Date(c.zi || c.startDate).getDate() &&
                                  current.getMonth() ===
                                    new Date(c.zi || c.startDate).getMonth() &&
                                  current.getFullYear() ===
                                    new Date(c.zi || c.startDate).getFullYear()
                              )
                              .map((c) => ({ ...c, columnsActivitate: acis })),
                          ];
                        }, [])
                        .sort((a, b) => {
                          return a.zi - b.zi;
                        })
                        .filter((c) => c?.materieId?.includes('Admin'))}
                      pagination={false}
                    />
                  </div>
                </>
              );
            })}
        </div>
      </div>
    );
  else if (condicaProfi && perCadru === false)
    return (
      <div className='condica-export' ref={componentRef}>
        {zile.map((current, index) => {
          let ziLibera = false;
          if (current.getDay() == 6 || current.getDay() == 0) return <></>;
          if (
            zileLibere?.find((C) => {
              return (
                current.getDate() === C.getDate() &&
                current.getMonth() === C.getMonth() &&
                current.getFullYear() === C.getFullYear()
              );
            })
          )
            ziLibera = true;
          let recuperare = false;
          if (
            recuperari?.find((C) => {
              return (
                current.getDate() === C.getDate() &&
                current.getMonth() === C.getMonth() &&
                current.getFullYear() === C.getFullYear()
              );
            })
          ) {
            recuperare = true;
            ziLibera = false;
          }
          let acis = false;

          if (
            activitateInScoala?.find((d) => {
              let start = new Date(d.s.getTime());
              let end = new Date(d.e.getTime());
              start.setUTCHours(0, 0, 0, 0);
              end.setUTCHours(0, 0, 0, 0);
              let dt = current;
              if (start <= dt && end >= dt) return true;
              return false;
            })
          )
            acis = true;

          return (
            <div key={index} style={{ textAlign: 'center' }}>
              <br />
              <br />
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <p>Ziua: {current.getDate()}</p>
                <p>Luna: {formatterLuna.format(current)}</p>
                <p>Anul: {current.getFullYear()}</p>
              </div>
              <br />
              <div style={{ padding: '5px' }}>
                <Table
                  columns={
                    acis === true
                      ? columnsActivitate
                      : recuperare === true
                      ? columnsRecuperare
                      : columns
                  }
                  dataSource={[
                    ...(ziLibera ||
                    vc?.find((d) => {
                      let start = new Date(d.s.getTime());
                      let end = new Date(d.e.getTime());
                      start.setUTCHours(0, 0, 0, 0);
                      end.setUTCHours(0, 0, 0, 0);
                      let dt = current;
                      if (start <= dt && end >= dt) return true;
                      return false;
                    })
                      ? profesori
                          .filter((p) =>
                            condica
                              .filter((c) => !c.materieId?.includes('Admin'))
                              .find((pa) => pa.profId === p.id)
                          )
                          .map((p) => ({
                            id:
                              current.getDate() +
                              'zi' +
                              current.getMonth() +
                              'an' +
                              current.getFullYear(),
                            subiectLectie: '',
                            profId: p.id,

                            displayName: p.displayName,
                            startDate: current,
                            tip: 'toataziua',
                            zi: zileLibere?.find((c) => {
                              return (
                                current.getDate() ===
                                  new Date(c.zi || c.startDate).getDate() &&
                                current.getMonth() ===
                                  new Date(c.zi || c.startDate).getMonth() &&
                                current.getFullYear() ===
                                  new Date(c.zi || c.startDate).getFullYear()
                              );
                            }),
                            vacanta: true,
                            recuperare,
                            zi: current,
                            ziLibera,
                            columnsActivitate: acis,
                          }))
                          .sort((a, b) => {
                            if (a.displayName < b.displayName) return -1;
                            if (a.displayName > b.displayName) return 1;
                            if (compareDates(a, b) === 0) {
                              if (a.displayName === b.displayName) {
                                let classA = clase?.find(
                                  (c) => c.id == a.classId
                                );
                                let classB = clase?.find(
                                  (c) => c.id == b.classId
                                );
                                if (!a.classId || !b.classId) {
                                  if (a.displayName < b.displayName) return -1;
                                  else return 1;
                                }
                                let AniSort = [
                                  'Pregătitoare',
                                  'I',
                                  'II',
                                  'III',
                                  'IV',
                                  'V',
                                  'VI',
                                  'VII',
                                  'VIII',
                                  'IX',
                                  'X',
                                  'XI',
                                  'XII',
                                ];
                                if (
                                  AniSort.findIndex(
                                    (a) => a === classA.anClasa
                                  ) <
                                  AniSort.findIndex((a) => a === classB.anClasa)
                                )
                                  return -1;
                                else if (
                                  AniSort.findIndex(
                                    (a) => a === classA.anClasa
                                  ) >
                                  AniSort.findIndex((a) => a === classB.anClasa)
                                )
                                  return 1;
                                else
                                  return classA.identificator.localeCompare(
                                    classB.identificator
                                  );
                              }
                              return compareDates(a, b);
                            } else return compareDates(a, b);
                          })
                      : condica

                          .filter(
                            (c) =>
                              current.getDate() ===
                                new Date(c.zi || c.startDate).getDate() &&
                              current.getMonth() ===
                                new Date(c.zi || c.startDate).getMonth() &&
                              current.getFullYear() ===
                                new Date(c.zi || c.startDate).getFullYear() &&
                              (vacante === true ||
                                (vacante === false && c.vacanta !== true))
                          )
                          .sort((a, b) => {
                            if (a.displayName < b.displayName) return -1;
                            if (a.displayName > b.displayName) return 1;
                            if (compareDates(a, b) === 0) {
                              if (a.displayName === b.displayName) {
                                let classA = clase?.find(
                                  (c) => c.id == a.classId
                                );
                                let classB = clase?.find(
                                  (c) => c.id == b.classId
                                );
                                if (!a.classId || !b.classId) {
                                  if (a.displayName < b.displayName) return -1;
                                  else return 1;
                                }
                                let AniSort = [
                                  'Pregătitoare',
                                  'I',
                                  'II',
                                  'III',
                                  'IV',
                                  'V',
                                  'VI',
                                  'VII',
                                  'VIII',
                                  'IX',
                                  'X',
                                  'XI',
                                  'XII',
                                ];
                                if (
                                  AniSort.findIndex(
                                    (a) => a === classA.anClasa
                                  ) <
                                  AniSort.findIndex((a) => a === classB.anClasa)
                                )
                                  return -1;
                                else if (
                                  AniSort.findIndex(
                                    (a) => a === classA.anClasa
                                  ) >
                                  AniSort.findIndex((a) => a === classB.anClasa)
                                )
                                  return 1;
                                else
                                  return classA.identificator.localeCompare(
                                    classB.identificator
                                  );
                              }
                              return compareDates(a, b);
                            } else return compareDates(a, b);
                          })
                          // Group same teacher + same time entries
                          .reduce((acc, current) => {
                            const sameTimeIndex = acc.findIndex(
                              (item) =>
                                item.displayName === current.displayName &&
                                retriveHourCorectly(
                                  item.startDate,
                                  'start',
                                  null,
                                  item
                                ) ===
                                  retriveHourCorectly(
                                    current.startDate,
                                    'start',
                                    null,
                                    current
                                  ) &&
                                retriveHourCorectly(
                                  item.endDate,
                                  'end',
                                  item.startDate,
                                  item
                                ) ===
                                  retriveHourCorectly(
                                    current.endDate,
                                    'end',
                                    current.startDate,
                                    current
                                  )
                            );

                            if (sameTimeIndex !== -1) {
                              // Group with existing entry
                              const existingItem = acc[sameTimeIndex];
                              const currentClass = clase?.find(
                                (cls) => cls.id === current.classId
                              );
                              const existingClass = clase?.find(
                                (cls) => cls.id === existingItem.classId
                              );

                              // Combine class information
                              const existingClassInfo = existingClass
                                ? (
                                    (existingClass.anClasa || '') +
                                    ' ' +
                                    (existingClass.identificator || '')
                                  ).trim()
                                : existingItem.classId || '';
                              const currentClassInfo = currentClass
                                ? (
                                    (currentClass.anClasa || '') +
                                    ' ' +
                                    (currentClass.identificator || '')
                                  ).trim()
                                : current.classId || '';

                              const combinedClassInfo =
                                existingItem.classId &&
                                existingItem.classId.includes(' + ')
                                  ? existingItem.classId +
                                    (currentClassInfo
                                      ? ' + ' + currentClassInfo
                                      : '')
                                  : existingClassInfo && currentClassInfo
                                  ? existingClassInfo + ' + ' + currentClassInfo
                                  : existingClassInfo || currentClassInfo || '';

                              acc[sameTimeIndex] = {
                                ...existingItem,
                                classId: combinedClassInfo,
                                materieId:
                                  existingItem.materieId || current.materieId,
                                textOra:
                                  existingItem.textOra || current.textOra,
                              };
                            } else {
                              acc.push(current);
                            }
                            return acc;
                          }, [])
                          .map((e, i, arr) => ({
                            ...e,
                            marked:
                              (arr[i - 1]?.displayName === e.displayName &&
                                retriveHourCorectly(
                                  arr[i - 1].startDate,
                                  'start',
                                  null,
                                  arr[i - 1]
                                ) ===
                                  retriveHourCorectly(
                                    e.startDate,
                                    'start',
                                    null,
                                    e
                                  )) ||
                              (arr[i + 1]?.displayName === e.displayName &&
                                retriveHourCorectly(
                                  arr[i + 1].startDate,
                                  'start',
                                  null,
                                  arr[i + 1]
                                ) ===
                                  retriveHourCorectly(
                                    e.startDate,
                                    'start',
                                    null,
                                    e
                                  )),
                          }))),
                    // Add empty rezerva entries only if it's NOT a free day
                    ...(!(
                      ziLibera ||
                      vc?.find((d) => {
                        let start = new Date(d.s.getTime());
                        let end = new Date(d.e.getTime());
                        start.setUTCHours(0, 0, 0, 0);
                        end.setUTCHours(0, 0, 0, 0);
                        let dt = current;
                        return start <= dt && end >= dt;
                      })
                    )
                      ? [
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                          { rezerva: true },
                        ]
                      : []),
                  ]}
                  pagination={false}
                />
                <p style={{ textAlign: 'center', paddingTop: '50px' }}>
                  Director / Director adjunct,
                </p>
              </div>
              <br />
            </div>
          );
        })}
      </div>
    );
  else if (perCadru === false)
    return (
      <div className='condica-export' ref={componentRef}>
        {zile.map((current, index) => {
          if (current.getDay() == 6 || current.getDay() == 0) return <></>;
          let acis = false;
          if (
            activitateInScoala?.find((d) => {
              let start = new Date(d.s.getTime());
              let end = new Date(d.e.getTime());
              start.setUTCHours(0, 0, 0, 0);
              end.setUTCHours(0, 0, 0, 0);
              let dt = current;
              if (start <= dt && end >= dt) return true;
              return false;
            })
          )
            acis = true;
          return (
            <div
              key={index}
              style={{ pageBreakAfter: 'always', textAlign: 'center' }}
            >
              <br />
              <br />
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <p>Ziua: {current.getDate()}</p>
                <p>Luna: {formatterLuna.format(current)}</p>
                <p>Anul: {current.getFullYear()}</p>
              </div>
              <br />
              <div>
                <Table
                  columns={columnsAdmin}
                  dataSource={condica
                    .filter((c) => c?.materieId?.includes('Admin'))
                    .filter(
                      (c) =>
                        current.getDate() ===
                          new Date(c.zi || c.startDate).getDate() &&
                        current.getMonth() ===
                          new Date(c.zi || c.startDate).getMonth() &&
                        current.getFullYear() ===
                          new Date(c.zi || c.startDate).getFullYear()
                    )
                    .sort((a, b) => a.startDate - b.startDate)
                    .map((c) => ({ ...c, columnsActivitate: acis }))}
                  pagination={false}
                />
              </div>
              <br />
            </div>
          );
        })}
      </div>
    );
};

export default CondicaExport;
